import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

const SearchTypeSelector = ({ searchType, setSearchType, disabled }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  
  const options = [
	  { value: 'email', label: 'Email' },
	  { value: 'subject', label: 'Subject' },
	  { value: 'envelopeId', label: 'EnvID' },
	  { value: 'name', label: 'Name' }
  ];

  return (
    <div className="relative">
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-white text-black font-normal hover:bg-gray-100 inline-flex items-center justify-between h-10 px-4 py-2 w-40"
        disabled={disabled}
      >
        <span className="flex-1 text-left">
          Search by: {options.find(opt => opt.value === searchType)?.label}
        </span>
        <ChevronDown className="h-4 w-4 ml-2 flex-shrink-0" />
      </Button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute z-50 mt-1 w-40 bg-white rounded-md shadow-lg">
            <div className="py-1">
              {options.map((option) => (
                <button
                  key={option.value}
                  onClick={() => {
                    setSearchType(option.value);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                    searchType === option.value ? 'bg-gray-50' : ''
                  }`}
                >
                  Search by {option.label}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SearchTypeSelector;